import { h, Component } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';
import SimpleField from 'components/editor/settings/simpleField';
import DateField from 'components/editor/settings/dateField';
import Toggle from 'components/toggle/toggle';
import s from 'components/editor/settings/fieldWithToggle.sss';

export default class FieldWithToggle extends Component {

	constructor(props) {
		super(props);
		const toggled = jsonPointer.get(Store.get().data, this.props.togglePath) ?? this.props.toggleDefault ?? false;
		this.state = {
			toggled: toggled,
		};
		this.onToggle = this.onToggle.bind(this);
	}

	onToggle(e) {
		const toggled = e.target.checked;
		const value = toggled ? (this.previousValue || this.defaultValue || true) : false;
		if (value === false) {
			this.previousValue = this.value;
		}
		if (this.props.togglePath) {
			jsonPointer.setDeep(Store.get().data, this.props.togglePath, value);
		}
		this.setState({ toggled });
		this.props.onInput?.({ target: { value } });
	}

	render() {
		return (
			<div class={s.wrapper}>
				{this.props.date ? (
					<DateField
						label={this.props.label}
						help={this.props.help}
						path={this.props.fieldPath}
						placeholder={this.props.placeholder || ''}
						disabled={this.state.toggled}
					/>
				) : (
					<SimpleField 
						label={this.props.label}
						help={this.props.help}
						path={this.props.fieldPath}
						placeholder={this.props.placeholder || ''}
						disabled={this.state.toggled}
						multiline={this.props.multiline}
					/>
				)}
				<Toggle 
					checked={this.state.toggled}
					onInput={this.onToggle}
					class={s.toggle}
				>
					{this.props.toggleLabel || 'Disable this field'}
				</Toggle>
			</div>
		);
	}
}